module.exports = __webpack_public_path__ + "static/assets/c79988bb17fdba37fe2d1ee3eacf9f5f.png";